if (document.getElementById('page-cart')) {
  pageCart()
}
function pageCart() {
  //  ####    #####  ##
  //  ##  ##  ##     ##
  //  ##  ##  #####  ##
  //  ##  ##  ##     ##
  //  ####    #####  ######

  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-cartDel')) {
      return
    }

    const targetBtn = document.querySelector('.js-cartDel--' + e.target.dataset.id).innerHTML
    const targetName = e.target.dataset.title
    window.dialogOpen('削除確認', targetBtn)
  })
  //  #####   ##   ##  ##    ##
  //  ##  ##  ##   ##   ##  ##
  //  #####   ##   ##    ####
  //  ##  ##  ##   ##     ##
  //  #####    #####      ##

  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-cartBuy')) {
      return
    }

    const targetBtn = document.querySelector('.js-cartBuy--dialog').innerHTML
    const targetName = e.target.dataset.title
    window.dialogOpen('購入内容確認', targetBtn)
  })
}
